var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIntentionality = function SvgIntentionality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.35 24.07a1 1 0 0 1 1.5.864v6.063a1 1 0 0 1-1.5.866l-5.25-3.03a1 1 0 0 1 0-1.733z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 22.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.937 2.603A14 14 0 1 1 15.999 30a2 2 0 1 1 0-4 10 10 0 1 0-7.07-2.93A2 2 0 0 1 6.1 25.9a14 14 0 0 1 5.837-23.297",
    clipRule: "evenodd"
  })));
};
export default SvgIntentionality;